<template>
    <component
        :is="as"
        v-bind="attrs"
        :class="[
            'tw:flex tw:items-center tw:gap-1 tw:p-2',
            { 'tw:text-zinc-300/80 tw:hover:text-zinc-200': !active },
            { 'tw:text-white': active }
        ]"
    >
        <slot />
    </component>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

defineProps({
    as: {
        type: [String, Object],
        default: 'a',
    },
    active: {
        type: Boolean,
        default: false,
    }
})

const attrs = useAttrs()
</script>
